/** Honey spinner ring with the bobbing bee mascot. */
export function BeeLoader({ size = 56 }: { size?: number }) {
  return (
    <div className="wb-bee-loader" style={{ width: size, height: size }}>
      <div className="wb-ring" />
      <img src="/weebee-bee.png" alt="" style={{ width: size * 0.54, height: size * 0.54 }} />
    </div>
  );
}
